/* eslint-disable */
import axios from 'axios'

const passengerService = {
    getPaymentOptions(searchId){
        return new Promise((resolve)=>{
            let data = "";
            if (searchId!=null) data = "pSearchId=" + searchId;
            axios.post(
                "/api/Go/GetPaymentOptions",
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });
    },
    savePassengerInfo(data){
        return new Promise((resolve)=>{
            axios.post(
                "/api/Flight2C_2/Next",
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            })
        });
    },
    createBooking(paymentType, merchantType){
        return new Promise((resolve)=>{
            axios.post(
                "/api/Flight2C_3/CreateBooking",
                "paymentSelection=" + encodeURIComponent( paymentType)+ "&merchantSelection=" +  encodeURIComponent( merchantType)
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            })
        });
    },
    getPassengerViewModels(){
        
        return new Promise((resolve)=>{
            axios.post(
                "/api/Go/GetPassengerViewModels",
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            })
        });        
    },
}

export default passengerService